import { getLatestLoanApplicationData } from '~/api/loan';

export default {
  methods: {
    /**
     * Check user's bayar tempo state
     * @command - [apicall] checkBayarTempoState [/apicall]
     */
    async checkBayarTempoState() {
      const responses = {
        bayarTempoState: '[apiresponse] bayarTempoStateIs<state> [/apiresponse]',
        checkBayarTempoStateError: '[apiresponse] checkBayarTempoStateError [/apiresponse]',
      };

      try {
        const { data: loanApplicationData } = await getLatestLoanApplicationData(this.$axios, {
          productType: 'bayar-tempo',
        });

        /**
         * Possible states
         * pending | approved | rejected
         */
        const { state } = loanApplicationData;
        const capitalizedState = state.charAt(0).toUpperCase() + state.slice(1);
        const finalResponse = responses.bayarTempoState.replace('<state>', capitalizedState);
        this.$zopim.sendChatMsg(finalResponse);
      } catch (error) {
        this.$zopim.sendChatMsg(responses.checkBayarTempoStateError);
        console.error('[ERROR] Something is wrong when trying to check user bayar tempo state', error);
      }
    },
  },
};
